import { createLogger } from 'browser-bunyan';

import { VerbFetch } from '../VerbFetch';
import { IS_BROWSER } from '../Constants';
import { useContext } from 'react';
import { RuntimeContext } from '../../../common/RuntimeContext';

let store;
export const setReduxStore = (newStore) => {
    store = newStore;
};

const levels = {
    TRACE: 10,
    DEBUG: 20,
    INFO: 30,
    WARN: 40,
    ERROR: 50,
    FATAL: 60
};

function ConsoleRawStream() {};

const contextType = RuntimeContext._currentValue;

const environment = contextType.pathsWeb.environment;

const logForLowerEnvs = environment.includes('qsb')
                        || environment.includes('rc')
                        || environment.includes('dev')
                        || environment.includes('local');

ConsoleRawStream.prototype.write = rec => {
    if(logForLowerEnvs) {
         console.log(rec)
    } else {
        if (rec.level > levels.WARN) {
            console.log(rec);
        }
    }
};

const streams = [
    {
        level: 'info',
        type: 'raw',
        stream: new ConsoleRawStream(),
        closeOnExit: false
    }
];

function ServerStream() {}

// Setting up the Server Logger
// if (IS_BROWSER) {
//     let recordBuffer = [];
//     const sendServerLogs = () => {
//         const records = recordBuffer;
//         recordBuffer = [];
//         if (records.length) {
//             VerbFetch( 'https://api.dev.verb.net/browserlog', {
//                 method: 'POST',
//                 body: {
//                     records
//                 }
//             });
//         }
//     };
//     ServerStream.prototype.write = (rec) => {
//         rec.time = rec.time.toISOString();
//         rec.userAgent = window.navigator ? window.navigator.userAgent : '';
//         delete rec.levelName;
//         if (store) {
//             const state = store.getState();
//             if (state.session && state.session.sessionId) {
//                 rec.sid = state.session.sessionId;
//             }
//         }
//         recordBuffer.push(rec);
//     };
//
//     streams.push({
//         level: 'debug',
//         type: 'raw',
//         stream: new ServerStream(),
//         closeOnExit: false
//     });
//     if (!window.__NO_LOG_INTERVAL__) {
//         setInterval(sendServerLogs, 30000); // Releases the buffer every 30 seconds
//         window.addEventListener('beforeunload', () => {
//             sendServerLogs(); // Attempts to release the buffer before the tab is closed
//             return null; // Need to return null so there is no alert
//         });
//     }
// }

const log = createLogger({
    name: 'Paths-Web',
    streams
});

if (IS_BROWSER) {
    window.onerror = (msg, url, lineNumber, columnNumber, err) => {
        const errorObj = {};
        Object.getOwnPropertyNames(err).forEach((key) => {
            errorObj[key] = err[key];
        });
        log.error(errorObj);
    };
}

export default log;
